import { trpc as IssueTapdTemplate } from '@tencent/tpro_rmonitor_manage_server_issue_tapd_template';
import { trpc as IssueTrack } from '@tencent/tpro_rmonitor_manage_server_issue_track';
import { trpc as Tapd } from '@tencent/tpro_rmonitor_manage_server_tapd';
import { trpc as UserCustom } from '@tencent/tpro_rmonitor_manage_server_user_custom';
import { trpc as Product } from '@tencent/tpro_rmonitor_product_manager_product';
import { WithTypeCast } from '@raft/utils';

// eslint-disable-next-line max-len
export type IGetIssueTapdTemplateInfosReq = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.IGetIssueTapdTemplateInfosReq>;
// eslint-disable-next-line max-len
export type IGetIssueTapdTemplateInfosRsp = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.IGetIssueTapdTemplateInfosRsp>;
export type ITapdTemplateInfos = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.GetIssueTapdTemplateInfosRsp
  .ITapdTemplateInfos>;
export type IStatusLinkageRule = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.IStatusLinkageRule>;
export type IBasicItemInfo = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.IBasicItemInfo>;
// eslint-disable-next-line max-len
export type ISaveIssueTapdTemplateInfosRsp = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.ISaveIssueTapdTemplateInfosRsp>;
// eslint-disable-next-line max-len
export type ISaveIssueTapdTemplateInfosReq = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.ISaveIssueTapdTemplateInfosReq>;
// eslint-disable-next-line max-len
export type IDeleteIssueTapdTemplateInfoReq = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.IDeleteIssueTapdTemplateInfoReq>;
// eslint-disable-next-line max-len
export type IDeleteIssueTapdTemplateInfoRsp = WithTypeCast<IssueTapdTemplate.rmonitor.manage_server.IDeleteIssueTapdTemplateInfoRsp>;

export type IModifyIssueStatusReq = WithTypeCast<IssueTrack.rmonitor.manage_server.IModifyIssueStatusReq>;
export type IModifyIssueStatusRsp = WithTypeCast<IssueTrack.rmonitor.manage_server.IModifyIssueStatusRsp>;
export type IModifyIssueListStatusReq = WithTypeCast<IssueTrack.rmonitor.manage_server.IModifyIssueListStatusReq>;

export type ICreateTapdIssueReq = WithTypeCast<IssueTrack.rmonitor.manage_server.ICreateTapdIssueReq>;
export type ICreateTapdIssueRsp = WithTypeCast<IssueTrack.rmonitor.manage_server.ICreateTapdIssueRsp>;

export type IBindTapdIssueReq = WithTypeCast<IssueTrack.rmonitor.manage_server.IBindTapdIssueReq>;
export type IBindTapdIssueRsp = WithTypeCast<IssueTrack.rmonitor.manage_server.IBindTapdIssueRsp>;

export type IReleaseTapdIssueReq  = WithTypeCast<IssueTrack.rmonitor.manage_server.IReleaseTapdIssueReq>;
export type IReleaseTapdIssueRsp = WithTypeCast<IssueTrack.rmonitor.manage_server.IReleaseTapdIssueRsp>;

export type IGetTapdInfoReq = WithTypeCast<Tapd.rmonitor.manage_server.IGetTapdInfoReq>;
export type IGetTapdInfoResp = WithTypeCast<Tapd.rmonitor.manage_server.IGetTapdInfoResp>;
export type ITapdInfo = WithTypeCast<Tapd.rmonitor.manage_server.ITapdInfo>;

export type IAddTapdInfoReq = WithTypeCast<Tapd.rmonitor.manage_server.IAddTapdInfoReq>;
export type IAddTapdInfoResp = WithTypeCast<Tapd.rmonitor.manage_server.IAddTapdInfoResp>;

// 删除Tapd
export type IDeleteTapdInfoReq = WithTypeCast<Tapd.rmonitor.manage_server.IDeleteTapdInfoReq>;
export type IDeleteTapdInfoResp = WithTypeCast<Tapd.rmonitor.manage_server.IDeleteTapdInfoResp>;

export type IGetCustomFieldsReq = WithTypeCast<Tapd.rmonitor.manage_server.IGetCustomFieldsReq>;
export type IGetCustomFieldsResp = WithTypeCast<Tapd.rmonitor.manage_server.IGetCustomFieldsResp>;

export type IGetTapdOAuthReq = WithTypeCast<Tapd.rmonitor.manage_server.IGetTapdOAuthReq>;
export type IGetTapdOAuthResp = WithTypeCast<Tapd.rmonitor.manage_server.IGetTapdOAuthResp>;

export type IListDimensionsReq = WithTypeCast<UserCustom.rmonitor.manage_server.IListDimensionsReq>;
export type IListDimensionsRsp = WithTypeCast<UserCustom.rmonitor.manage_server.IListDimensionsRsp>;
export type IDimension = WithTypeCast<UserCustom.rmonitor.manage_server.IDimension>;
export type ICommonRsp = WithTypeCast<UserCustom.rmonitor.manage_server.ICommonRsp>;

// 产品
export type IApplyProductReq = WithTypeCast<Product.rmonitor.product_manager.IApplyProductReq>;
export type IApplyProductRsp = WithTypeCast<Product.rmonitor.product_manager.IApplyProductRsp>;
export type IGetProductInfoReq = WithTypeCast<Product.rmonitor.product_manager.IGetProductInfoReq>;
export type IGetProductInfoRsp = WithTypeCast<Product.rmonitor.product_manager.IGetProductInfoRsp>;
export type IProductDetailInfo = WithTypeCast<Product.rmonitor.product_manager.IProductDetailInfo>;
export type IAllowCreateReq = WithTypeCast<Product.rmonitor.product_manager.IAllowCreateReq>;
export type IAllowCreateRsp = WithTypeCast<Product.rmonitor.product_manager.IAllowCreateRsp>;
export type IGetApplicationReq = WithTypeCast<Product.rmonitor.product_manager.IGetApplicationReq>;
export type IGetApplicationRsp = WithTypeCast<Product.rmonitor.product_manager.IGetApplicationRsp>;
export type IApply = WithTypeCast<Product.rmonitor.product_manager.IApply>;
export type IGetApprovalReq = WithTypeCast<Product.rmonitor.product_manager.IGetApprovalReq>;
export type IGetApprovalRsp = WithTypeCast<Product.rmonitor.product_manager.IGetApprovalRsp>;
export type IGetApplyDedailReq = WithTypeCast<Product.rmonitor.product_manager.IGetApplyDedailReq>;
export type IGetApplyDedailRsp = WithTypeCast<Product.rmonitor.product_manager.IGetApplyDedailRsp>;

export type IGetBuglyqqProductsReq = WithTypeCast<Product.rmonitor.product_manager.IGetBuglyqqProductsReq>;
export type IGetBuglyqqProductsRsp = WithTypeCast<Product.rmonitor.product_manager.IGetBuglyqqProductsRsp>;

export type IGetProductInfosReq = WithTypeCast<Product.rmonitor.product_manager.IGetProductInfosReq>;
export type IGetProductInfosRsp = WithTypeCast<Product.rmonitor.product_manager.IGetProductInfosRsp>;
export const { OrgType, AppForm } = Product.rmonitor.product_manager;


